import React from "react";
import { number, object } from "prop-types";
import get from "lodash/get";

import HeadPhoneIcon from "../icons/head-phone";
import PlayIcon from "../icons/play-icon";
import CameraIcon from "../icons/camera-icon";

import "./headlineIcon.m.css";

const HeadlineIcon = ({ story, width = 15, height = 15 }) => {
  if (!story) {
    return null;
  }

  const sections = story.sections || [];
  const hasVideoAsSection = sections.map((s) => s.slug).includes("videos");

  const type = story["story-template"] || null;
  let view = null;

  switch (type) {
    case "podcast":
      view = <HeadPhoneIcon width={width} height={height} />;
      break;

    case "photo":
      view = <CameraIcon width={width} height={height} />;
      break;

    case "video":
      view = <PlayIcon width={width} height={height} />;
      break;

    default:
      break;
  }

  if (!view) {
    // Check if 1st section is podcast
    if (get(story, ["sections", "0", "slug"], null) === "podcast") {
      view = <HeadPhoneIcon width={width} height={height} />;
    } else if (hasVideoAsSection) {
      view = <PlayIcon width={width} height={height} />;
    }
  }

  if (view) {
    return (
      <div styleName="headline-icon-wrapper" className="headline-icon-wrapper">
        {view}
      </div>
    );
  }

  return null;
};

HeadlineIcon.propTypes = {
  story: object.isRequired,
  width: number,
  height: number,
};

export default HeadlineIcon;
